export default __webpack_public_path__ + "static/media/G0860.Breech_semirecum_delay4.1692880560000.295cb830.jpg";